// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2iSIA","inputWrap":"styles_inputWrap__3Rl6i","input":"styles_input__1OQ1D"};